module.exports = __webpack_public_path__ + "static/media/avatar-4.72f6e795.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatars/avatar-4.png
// module id = 243
// module chunks = 0